export const EMPTY_ROUTE_ITEM = {
  estabelecimento: '',
  data: '',
  endereco: '',
  municipio: '',
  motivo: '',
  diaria: '',
  tipoDiaria: '',
  realizada: null
}

export const ESTADOS = [
  { value: 'PB', label: 'Paraíba' },
  { value: 'AL', label: 'Alagoas' },
  { value: 'PE', label: 'Pernambuco' },
  { value: 'RN', label: 'Rio Grande do Norte' }
]

export const MOTIVOS = [
  'FISCALIZAÇÃO ORDINÁRIA',
  'REVISITA',
  'DENÚNCIA',
  'REQUISIÇÃO EXTERNA',
  'SERVIÇO NOVO'
]

export const DIARIA_OPTIONS = ['Sim', 'Não']
export const TIPO_DIARIA_OPTIONS = ['NÃO SE APLICA', 'PERNOITE', 'SEM PERNOITE']

export const createEmptyRouteItem = () => ({ ...EMPTY_ROUTE_ITEM })

export const formatDate = (value) => {
  if (!value) return 'Não informada'
  const [ano, mes, dia] = value.split('-')
  if (!ano || !mes || !dia) return value
  return `${dia}/${mes}/${ano}`
}

export const getNormalizedRoute = (route = {}) => route.normalized || {
  itensPrincipais: [],
  itensAlternativos: [],
  analytics: {},
  decision: { situacao: route.situacao || 'aberta' }
}

export const formatDateTimeInBrasilia = (value) => {
  if (!value) return 'Não informado'

  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value

  return new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  }).format(date)
}
